import { Select } from "antd";
import useTimeZone from "../hooks/useTimeZone";
import { IoIosArrowDown } from "react-icons/io";

const TimezoneSelector = ({ className = "" }) => {
  const userTimezone = Intl.DateTimeFormat()
    .resolvedOptions()
    .timeZone?.split("/")?.[1];
  const { timeZone, changeTimeZone } = useTimeZone();

  const handleChange = (value) => {
    changeTimeZone(value);
  };

  return (
    <Select
      className={className}
      value={timeZone}
      onChange={handleChange}
      style={{ width: 220 }}
      suffixIcon={<IoIosArrowDown color="#374151" />}
      options={[
        { value: "local", label: userTimezone },
        { value: "utc", label: "UTC" },
      ]}
    />
  );
};

export default TimezoneSelector;
